'use client'

import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { UiState } from '@marketplace-web/shared/ui-state-util'

type Props = {
  show: boolean
  uiState: UiState
  onClick: () => void
}

const SearchArea = ({ show, uiState, onClick }: Props) => {
  const translate = useTranslate()

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (uiState === UiState.Pending) {
      event.preventDefault()

      return
    }

    onClick()
  }

  if (!show && uiState !== UiState.Pending) return null

  return (
    <div className="pickup-point-map__search-area-container">
      <div className="pickup-point-map__search-area-button">
        <Button
          text={translate('checkout.shipping.pickup_point_modal.map.search_this_area')}
          styling={Button.Styling.Filled}
          size={Button.Size.Medium}
          onClick={handleClick}
          isLoading={uiState === UiState.Pending}
          inline
        />
      </div>
    </div>
  )
}

export default SearchArea
